import { render, staticRenderFns } from "./ResendInvites.vue?vue&type=template&id=568c7588&"
import script from "./ResendInvites.vue?vue&type=script&lang=js&"
export * from "./ResendInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports